// extracted by mini-css-extract-plugin
export default {"rangesTooltipContent":"role_availability-module___rangesTooltipContent___faccac93","tooltipContent":"role_availability-module___tooltipContent___e20f46e0"};